import { prepareFlatStats } from './mappers/prepareFlatStats';
import { TFlatStatsResult } from './types';
import {
  fetchGetAvgPriceAndMortgageRate,
  IGetAvgPriceAndMortgageRateRequest,
  TGetAvgPriceAndMortgageRateResponse,
} from '../../repositories/investment-calculator/v1/get-avg-price-and-mortgage-rate';
import { IApplicationContext } from '../../types/applicationContext';

export async function getAvgPriceAndMortgageRate(
  context: IApplicationContext,
  parameters: IGetAvgPriceAndMortgageRateRequest,
): Promise<TFlatStatsResult> {
  const { httpApi, logger } = context;

  try {
    const response: TGetAvgPriceAndMortgageRateResponse = await fetchGetAvgPriceAndMortgageRate({
      httpApi,
      parameters,
    });

    if (response.statusCode !== 200) {
      return {
        success: false,
        message: response.response.message,
      };
    }

    return {
      success: true,
      data: prepareFlatStats(response.response),
    };
  } catch (ex) {
    logger.error(ex);

    return {
      success: false,
      message: 'Произошла непредвиденная ошибка',
    };
  }
}
